import { appRouterPaths } from 'services/navigation';
import { OrganizationsPage } from 'pages/Organizations';
import type { AppRouteProps } from '../types';

export const organizationsPageRoute: AppRouteProps = {
  path: appRouterPaths.organizations,
  element: <OrganizationsPage />,
};
